// extracted by mini-css-extract-plugin
export default {"item":"GuidelineItem-module__item--e7cb","title":"GuidelineItem-module__title--649b","content":"GuidelineItem-module__content--0979"};